import styles from './FJPlaceholder.module.less'
import React from 'react'
import classNames from 'classnames'

function FJPlaceholder(props) {
  const {active, children} = props;
  return (
    <div className={classNames(styles.box, {[styles.active]: active})}>
      {children}
    </div>
  );
}

export default FJPlaceholder;